// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__root-wuBTuE","slotTargetVersion":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__slotTargetVersion-dGEL0a","svg":"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__svg-c0Wsdc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__root-wuBTuE\",\"slotTargetVersion\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__slotTargetVersion-dGEL0a\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_dashboard-PlasmicCopyButton-module__svg-c0Wsdc\"}";
        // 1793541991878
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  